import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M27 8.89l-2 2v14.8l-5 1.93V15.88l-2 2v9.8l-7-2.34V8.38l6.36 2.38L22 10 10.14 6.05a.54.54 0 00-.28 0L3.45 7.59A2 2 0 002 9.51v16.84a2 2 0 002 2 2.15 2.15 0 00.55-.08L9.86 27a.61.61 0 01.27 0l8.7 2.9a.47.47 0 00.33 0l6.63-2.42a2 2 0 001.21-1.8V8.89zM9 25.22l-5 1.13V9.51l5-1.26z"/><path d="M13.64 14.49a.42.42 0 00-.14.28l-.5 3.45a.69.69 0 00.19.58.67.67 0 00.48.2l3.55-.5a.42.42 0 00.28-.14l.49-.49L29.8 6.08a.68.68 0 000-1L26.89 2.2a.67.67 0 00-.48-.2.7.7 0 00-.49.2z"/>';
export var MapDrawSVG = function MapDrawSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
MapDrawSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MapDrawSVG);